import { Button } from "antd";
import { ManageAdvertiserForm } from "components/Forms/ManageAdvertiserForm/ManageAdvertiserForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC, useState } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddAdvertiserDrawerProps {
    onSuccess?: () => void;
}

export const AddAdvertiserDrawer: FC<AddAdvertiserDrawerProps> = (props) => {
    const { t } = usePaldockTranslation("drawers.add-advertiser");
    const { t: tCommon } = usePaldockTranslation("common");
    const id = DrawerId.AddAdvertiser;
    const [canSubmit, setCanSubmit] = useState(false);

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button
                    size={"large"}
                    htmlType="submit"
                    type={"primary"}
                    form={FormId.AddUserForm}
                    disabled={!canSubmit}
                >
                    {tCommon("create")}
                </Button>
            }
        >
            <DrawerContent>
                <ManageAdvertiserForm onSuccess={props.onSuccess} onCanSubmitChange={setCanSubmit} mode="create" />
            </DrawerContent>
        </Drawer>
    );
};
